module.exports = __webpack_public_path__ + "img/remedium.c38939f8.png";